import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRegularRightLeadReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8l.2-.7q.3-.4 1-.4zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.3q.1-1 1.1-1.1zm4.5 1.6h.3q.8.4.8 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8l.2-.7q.3-.4 1-.4zM25.2 7.2q1 0 1.5 1l4.1 7q.5.7 0 1.5l-.8 1.4q-.8-.8-2.1-.9h-.4l.7-1.2-3.5-6.2H5.4l2.4 4.8a3 3 0 0 1 0 2.8l-2.4 4.8h9.8l-.2 1.2v1.4H2.2q-.8-.4-.5-1l3.8-7.6v-.4L1.7 8.3V8q.1-.8.8-.8h22.6" })
});
export default SvgChevronRegularRightLeadReportIcon;
